import { Injectable } from '@angular/core';

/** Matches the responsive shell/table CSS contract (`max-width: 1024px`). */
export const RESPONSIVE_MAX_WIDTH = 1024;

export function isResponsiveViewportWidth(width: number): boolean {
	return width <= RESPONSIVE_MAX_WIDTH;
}

@Injectable({
	providedIn: 'root',
})
export class ViewportService {
	// Indicates whether the current viewport is considered mobile
	private isMobile = false;

	constructor() {
		this.checkViewport();
		window.addEventListener('resize', () => this.checkViewport());
	}

	/**
	 * Checks the current window width and updates the isMobile flag.
	 */
	private checkViewport(): void {
		this.isMobile = isResponsiveViewportWidth(window.innerWidth);
	}

	/**
	 * Returns whether the current viewport is mobile.
	 * Can be used to adapt components based on screen size.
	 */
	isMobileView(): boolean {
		return this.isMobile;
	}
}
